import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Briefcase, Clock } from "lucide-react";
import { api } from "../lib/api";
import { PageHero, Loader } from "../components/ui-bits";
import { Reveal } from "../components/Reveal";

const BG = "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function Careers() {
  const [jobs, setJobs] = useState(null);
  const [dept, setDept] = useState("All");

  useEffect(() => {
    api.get("/jobs").then((r) => setJobs(r.data)).catch(() => setJobs([]));
  }, []);

  if (jobs === null) return <Loader label="Loading openings" />;

  const depts = ["All", ...Array.from(new Set(jobs.map((j) => j.department)))];
  const filtered = dept === "All" ? jobs : jobs.filter((j) => j.department === dept);

  return (
    <div data-testid="careers-page">
      <PageHero
        eyebrow="Careers"
        title="Build the future with us."
        subtitle="Join a global team empowering talent across technology, healthcare, infrastructure and beyond."
        bg={BG}
      />
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-wrap gap-2 mb-8" data-testid="careers-dept-filter">
          {depts.map((d) => (
            <button
              key={d}
              onClick={() => setDept(d)}
              data-testid={`careers-dept-${d.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${
                dept === d ? "bg-emerald-500 text-slate-950 border-emerald-500" : "border-slate-800 text-slate-300 hover:border-emerald-500/50"
              }`}
            >
              {d}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <p className="text-slate-500 py-20 text-center font-mono">No open positions in this department right now.</p>
        ) : (
          <div className="space-y-4">
            {filtered.map((j, i) => (
              <Reveal key={j.id} delay={(i % 6) * 0.04}>
                <Link
                  to={`/careers/${j.slug}`}
                  data-testid={`job-card-${j.slug}`}
                  className="card-vertical rounded-2xl p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4 group"
                >
                  <div>
                    <h3 className="font-display font-semibold text-white text-lg group-hover:text-emerald-400 transition-colors">{j.title}</h3>
                    <div className="flex flex-wrap gap-4 mt-3 text-sm text-slate-400">
                      <span className="flex items-center gap-1.5"><Briefcase className="w-4 h-4 text-emerald-400" /> {j.department}</span>
                      <span className="flex items-center gap-1.5"><MapPin className="w-4 h-4 text-emerald-400" /> {j.location}</span>
                      <span className="flex items-center gap-1.5"><Clock className="w-4 h-4 text-emerald-400" /> {j.type}</span>
                    </div>
                  </div>
                  <span className="btn-emerald px-5 py-2.5 rounded-full text-sm whitespace-nowrap self-start sm:self-auto">View &amp; Apply</span>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
